import { VCol } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCol,{staticClass:"pa-2",attrs:{"cols":"12"}},[_c('span',{staticClass:"font-weight-black primary--text headline"},[_vm._v(" "+_vm._s(_vm.$t(_vm.title))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }